import { render } from "./Dice.vue?vue&type=template&id=6cfd0f56"
import script from "./Dice.vue?vue&type=script&lang=js"
export * from "./Dice.vue?vue&type=script&lang=js"

import "./Dice.vue?vue&type=style&index=0&id=6cfd0f56&lang=css"

import exportComponent from "C:\\Users\\Kama484\\Monopoly\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__